/* eslint-disable */
export default {
  cancel: 'Peruuta',
  confirm: 'Vahvista',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
